import { render } from "./MyAdvisors.vue?vue&type=template&id=de4f177c&scoped=true"
import script from "./MyAdvisors.vue?vue&type=script&lang=js"
export * from "./MyAdvisors.vue?vue&type=script&lang=js"

import "./MyAdvisors.vue?vue&type=style&index=0&id=de4f177c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de4f177c"]])

export default __exports__